import { render } from "./CouriersList.vue?vue&type=template&id=c2cba7fe&scoped=true&ts=true"
import script from "./CouriersList.vue?vue&type=script&lang=ts"
export * from "./CouriersList.vue?vue&type=script&lang=ts"

import "./CouriersList.vue?vue&type=style&index=0&id=c2cba7fe&lang=scss&scoped=true"

import exportComponent from "/builds/spark/services/frontend/admin-v2/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c2cba7fe"]])

export default __exports__